import { BR } from './br';
import { EN } from './en';
import { ES } from './es';

export const LANGUAGES = {
  br: BR,
  en: EN,
  es: ES
};

export const DEFAULT_LANGUAGE = 'br';
